/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-02 11:24:30
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-28 14:55:22
 */
const order = () => import(/* webpackChunkName: "order" */ '../views/order/list/index.vue')
const orderDetail = () => import(/* webpackChunkName: "order" */ '../views/order/detail/index.vue')
const unpaidOrder = () => import(/* webpackChunkName: "order" */ '../views/order/unpaid/index.vue')
const orderRefund = () => import(/* webpackChunkName: "order" */ '../views/order/orderRefund/orderRefund')

export default [
  {
    path: 'orders',
    name: 'orders',
    meta: {
      name: '订单管理',
      keepAlive: true
    },
    redirect: { name: 'order' }
  },
  {
    path: 'order',
    name: 'order',
    meta: {
      menuData: 'orders',
      name: '订单列表',
      keepAlive: true
    },
    component: order
  },
  {
    path: 'orderDetail/:id',
    name: 'orderDetail',
    meta: {
      parentsName: 'order',
      name: '订单详情',
      backName: 'order',
      keepAlive: true
    },
    component: orderDetail
  },
  {
    path: 'unpaidOrder',
    name: 'unpaidOrder',
    meta: {
      parentsName: 'order',
      name: '待处理订单',
      keepAlive: true
    },
    component: unpaidOrder
  },
  {
    path: 'orderRefund/:id',
    name: 'orderRefund',
    meta: {
      parentsName: 'order',
      name: '订单退款',
      keepAlive: true
    },
    component: orderRefund
  }
]
